module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG519e847e83a3c41117b089967866c398.519e847e.png";